import { Event } from './event';

export class EnrolmentSelectionClearedEvent extends Event<void> {}
